export default "__VITE_ASSET__DEvNatEG__"